import {Box, Typography, useTheme} from "@mui/material";
import Column from "../../../../Common/Column";
import React from "react";

export const LastTierCard = ({tier, selected, onClick, sx}) => {
    const theme = useTheme();

    return <Box
        data-testid="last-tier"
        sx={{
            minHeight: "40px",
            margin: "10px 7px",
            border: "1px solid black",
            cursor: "pointer",
            borderRadius: "5px",
            display: "flex",
            alignItems: "center",
            padding: "10px 20px",
            backgroundColor: "white",
            borderColor: theme.palette.grey["500"],
            boxShadow: selected ? `0px 0px 5px 6px ${"#f5d7b3"}` : undefined,
            opacity: tier.disabled ? "0.5" : "1",
            pointerEvents: tier.disabled ? "none" : "auto",
            ...sx
        }}
        onClick={onClick}
    >
        {/* If the last tiers does not have any features */}
        {tier.features.length < 1 && (
            <Typography >
                Nej tak, jeg vælger {tier.name}annonce uden tilvalg til {tier.price} kr.
            </Typography>
        )}

        {/* If the last tier has features */}
        {tier.features.length > 0 && (
            <Column>
                <Typography>
                    {"Nej tak, jeg vælger " + tier.name + "annonce til " + tier.price + " kr."}
                </Typography>

                {tier.features.map((feature, index) => (
                    <Typography sx={{fontSize: "14px"}} key={index}>
                        {"• " + feature.description}
                    </Typography>
                ))}
            </Column>
        )}
    </Box>
}